export enum IconButtonType {
    BACK = <any>"BACK",
    FORWARD = <any>"FORWARD",
    LEFT = <any>"LEFT",
    RIGHT = <any>"RIGHT",
    CLOSE = <any>"CLOSE",
    TOP = <any>"TOP",
    EXIT = <any>"EXIT",
    REFRESH = <any>"REFRESH",
    MENU = <any>"MENU",
    SETTINGS = <any>"SETTINGS",
    INCREMENT = <any>"INCREMENT",
    DECREMENT = <any>"DECREMENT",
    REMOVE = <any>"REMOVE",
    SHOW = <any>"SHOW",
    HIDE = <any>"HIDE",
    SCAN = <any>"SCAN",
    SEARCH = <any>"SEARCH"
}



// WEBPACK FOOTER //
// ./src/app/buttons/icon-button/icon-button.ts